export const SentEmailRecipientFragment = gql`
  fragment SentEmailRecipientFragment on SentEmailRecipient {
    id
    recipient {
      id
      emailAddress
      user {
        ...UserDataFragment
      }
    }
  }
`

export const SentEmailFragment = gql`
  fragment SentEmailFragment on SentEmail {
    id
    subject
    sentAt
  }
`

export const SentEmailDetailedFragment = gql`
  fragment SentEmailDetailedFragment on SentEmail {
    ...SentEmailFragment
    html
    sentEmailRecipients {
      ...SentEmailRecipientFragment
    }
  }
`
